module.exports = "/_next/static/images/4e9c42c5d8b79bec15bbe254f1e9dce4-pj-woman-working@2x.jpg";